import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"user\"><path d=\"M256 9C119.6 9 9 119.6 9 256s110.6 247 247 247 247-110.6 247-247S392.4 9 256 9zm.7 62.2c65 0 117.8 52.7 117.8 117.8s-52.7 117.8-117.8 117.8S138.9 254 138.9 189 191.6 71.2 256.7 71.2zm-.7 387.7c-70.5 0-132.5-35.9-168.9-90.4 44.7-24.6 103-39.4 166.7-39.4 65.3 0 124.8 15.6 169.9 41.2-36.5 53.5-98 88.6-167.7 88.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol